import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';

import { AppFormFieldErrorDirective } from '@shared/directives/app-form-field-error.directive';
import { ButtonModule } from 'primeng/button';
import { TwoFactorAuthenticationService } from '../two-factor-authentication/service/two-factor-authentication.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { NotificationService } from '@shared/services/notifications/notification.service';
import { InputOtpModule } from 'primeng/inputotp';
import { getFirebaseErrorMessage } from '@core/services/auth-firebase/firebase-error-map';

@Component({
  selector: 'app-mfa-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AppFormFieldErrorDirective,
    ButtonModule,
    InputOtpModule,
  ],
  templateUrl: './mfa-login.component.html',
  styleUrls: ['./mfa-login.component.scss'],
})
export class MfaLoginComponent implements OnInit {
  form: FormGroup;
  submitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private twoFactorService: TwoFactorAuthenticationService,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.form = this.fb.group({
      code: [
        '',
        [Validators.required, Validators.minLength(6), Validators.maxLength(6)],
      ],
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.twoFactorService
      .verifyTotp(this.form.value.code)
      .pipe(finalize(() => (this.submitting = false)))
      .subscribe({
        next: () => {
          this.router.navigate(['/dashboard']);
        },
        error: (error) => {
          this.notificationService.show(
            'Error',
            'Error al iniciar sesión - detalles: ' +
              getFirebaseErrorMessage(error.code),
            'error'
          );
        },
      });
  }
}
